
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...path]",
      function () {
        return require("private-next-pages/[...path].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...path]"])
      });
    }
  